import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { trackLeadConversion } from "../lib/gtag";

export default function ThankYou() {
  const { state } = useLocation();
  const fired = useRef(false);

  useEffect(() => {
    if (!state?.converted || fired.current) return;
    fired.current = true;
    trackLeadConversion(state.leadType);
    window.history.replaceState({}, "", window.location.pathname);
  }, [state]);

  return (
    <div className="min-h-screen flex items-center justify-center px-5 noise" data-testid="thank-you-page">
      <div className="text-center max-w-lg">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-neon/10 text-neon shadow-neon">
          <CheckCircle2 size={44} />
        </div>
        <h1 className="mt-8 font-heading font-black text-4xl md:text-5xl tracking-tighter">REQUEST RECEIVED.</h1>
        <p className="mt-4 text-zinc-400">
          Thanks — your court details are with the Speedy team. We'll assess your project and be in touch shortly to confirm the next steps.
        </p>
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          <Link to="/" data-testid="thank-you-home" className="rounded-sm bg-neon px-7 py-4 font-bold text-obsidian shadow-neon">Back to Home</Link>
          <Link to="/gallery" data-testid="thank-you-gallery" className="rounded-sm border border-white/20 px-7 py-4 font-bold hover:border-neon hover:text-neon transition-colors">Explore the Archive</Link>
        </div>
      </div>
    </div>
  );
}
